<div class="wrapper">
  <div class="row" id="back">
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-0 banner-sec container-image">
      <div id="changePasswordSlider" class="carousel slide-fade w-100 h-100" data-ride="carousel">
        <div class="carousel-inner d-flex h-100">
          <div class="carousel-item active">
            <div class="slider-img img-1"></div>
            <img
              class="d-block img-fluid mx-auto"
              src="../../../../assets/images/WV/west-virginia-band.png"
              alt="West Virginia Banner" />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex col-lg-4 shadow align-items-center p-4 mx-auto rightLoginSet">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto d-flex align-items-center h-100">
        <div class="row justify-content-center h-100">
          @if (showLanguage) {
            <div class="col-md-12 text-right w-100">
              <a
                #langselect
                href="javascript:void(0)"
                role="button"
                tabindex="0"
                class="clsLangBtn"
                (click)="showLanguageDialog()"
                title="choose language translater to change English or Spanish">
                <div class="menuIcons d-inline-block position-relative align-middle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#0059bf">
                    <path
                      d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" />
                  </svg>
                </div>
                <span class="d-inline-block align-middle" aria-hidden="true"> English </span>
              </a>
            </div>
          }
          <div class="col-md-12 d-flex align-content-end flex-wrap w-100">
            <div class="clearfix text-left logo-group lg-mb-50">
              <div class="form-group mb-4">
                <div class="logo-group">
                  <span class="logo-img d-block">
                    <img src="../../../../assets/images/WV/wv_logo.png" class="cfaLogoTop" alt="West Virginia Logo" />
                  </span>
                  <span class="logo-text">
                    <h1 class="font-weight-bold logo-title">
                      Log into Communication & Operations Mobile Engagement Tool
                    </h1>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix loginBottomSet">
            <div class="col-md-12 login-content">
              <form (ngSubmit)="login()" [formGroup]="changePasswordForm" novalidate>
                <div class="clearfix">
                  <ng-container>
                    <!-- Current Password -->
                    <div class="form-group mb-3">
                      <p role="alert">
                        Please enter the verification code sent to your email, then create and confirm your password.
                      </p>
                    </div>

                    <div class="form-group mb-3">
                      <label aria-labelledby="currentpassword" for="currentpassword"
                        >Verification Code <span class="requiredfield text-danger">*</span></label
                      >
                      <input
                        #vcode
                        class="form-control"
                        type="code"
                        maxlength="6"
                        autofocus
                        placeholder="Enter Verification Code"
                        name="currentpassword"
                        id="currentpassword"
                        formControlName="currentpassword"
                        tabindex="0"
                        required />
                      @if (
                        changePasswordForm.controls.currentpassword.hasError('required') &&
                        changePasswordForm.controls.currentpassword.touched
                      ) {
                        <div class="p-error block">
                          <small role="alert">Required</small>
                        </div>
                      }
                    </div>

                    <!-- New Password -->
                    <div class="form-group mb-3 position-relative clearfix">
                      <label aria-label="Enter your New" for="newPassword"
                        >New Password
                        <span class="requiredfield text-danger">*</span>
                        <!-- Info icon to trigger popover -->
                        <!-- Info icon to trigger popover -->
                        <div class="tooltip-container">
                          <span class="info-icon-wrapper">
                            <p-button
                              class="password-overlay-icon"
                              (mouseenter)="showTooltip($event)"
                              (focus)="showTooltip($event)"
                              (mouseleave)="hideTooltip()"
                              (blur)="hideTooltip()"
                              icon="pi pi-info-circle ms-2"
                              label="" />
                          </span>
                          <!-- Popover content -->
                          @if (isTooltipVisible) {
                            <div class="tooltip-box tooltip-top">
                              <h6 class="heading">Password Requirements:</h6>
                              <ul class="pwdreg">
                                @for (req of passwordRequirements; track req) {
                                  <li>
                                    {{ req.text }}
                                    @if (req.children) {
                                      <ul class="password-requirements">
                                        @for (child of req.children; track child) {
                                          <li>{{ convertTextWithNumbers(child) }}</li>
                                        }
                                      </ul>
                                    }
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                        </div>
                      </label>
                      <input
                        id="newPassword"
                        class="form-control newpwd"
                        #showhidepassword
                        type="password"
                        placeholder="Enter New Password"
                        name="password"
                        formControlName="newPassword"
                        autocomplete="new-password webauthn"
                        tabindex="0"
                        maxlength="50"
                        required />
                      <button
                        type="button"
                        aria-label="View Password"
                        class="fa fa-eye clsNoBorder"
                        (click)="toggleShowPassword()"></button>
                      @if (
                        changePasswordForm.controls.newPassword.hasError('required') &&
                        changePasswordForm.controls.newPassword.touched
                      ) {
                        <div class="p-error block">
                          <small role="alert">Required</small>
                        </div>
                      }
                      <div class="autosuggest">
                        @for (error of errors; track error) {
                          <div class="p-error block">
                            <em class="pi pi-times-circle"></em>
                            <small role="alert">
                              {{ error }}
                            </small>
                          </div>
                        }
                      </div>
                    </div>

                    <!-- Confirm Password -->
                    <div class="form-group mb-3 position-relative clearfix">
                      <label aria-label="Re-Enter New" for="confirmNewPassword"
                        >Confirm Password <span class="requiredfield text-danger">*</span>

                        <!-- Info icon to trigger popover -->
                        <div class="tooltip-container">
                          <span class="info-icon-wrapper">
                            <p-button
                              class="password-overlay-icon"
                              (mouseenter)="showConfirmTooltip($event)"
                              (focus)="showConfirmTooltip($event)"
                              (mouseleave)="hideConfirmTooltip()"
                              (blur)="hideConfirmTooltip()"
                              icon="pi pi-info-circle ms-2"
                              label="" />
                          </span>
                          <!-- Popover content -->
                          @if (isConfirmTooltipVisible) {
                            <div class="tooltip-box tooltip-top">
                              <h6 class="heading">Password Requirements:</h6>
                              <ul class="pwdreg">
                                @for (req of passwordRequirements; track req) {
                                  <li>
                                    {{ req.text }}
                                    @if (req.children) {
                                      <ul class="password-requirements">
                                        @for (child of req.children; track child) {
                                          <li>{{ convertTextWithNumbers(child) }}</li>
                                        }
                                      </ul>
                                    }
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                        </div>
                      </label>
                      <input
                        id="confirmNewPassword"
                        class="form-control newpwd"
                        #showhideconfirmpassword
                        type="password"
                        placeholder="Re-Enter New Password"
                        autocomplete="password webauthn"
                        name="confirmNewPassword"
                        formControlName="confirmNewPassword"
                        tabindex="0"
                        maxlength="50"
                        required />
                      <button
                        type="button"
                        aria-label="View Password"
                        class="fa fa-eye clsNoBorder"
                        (click)="toggleShowConfirmPassword()"></button>
                      @if (
                        changePasswordForm.controls.confirmNewPassword.hasError('required') &&
                        changePasswordForm.controls.confirmNewPassword.touched
                      ) {
                        <div class="p-error block">
                          <small role="alert">Required</small>
                        </div>
                      }
                      @if (changePasswordForm.hasError('notMatched')) {
                        <div class="p-error block">
                          <small role="alert">Password does not match</small>
                        </div>
                      }
                      <div class="autosuggest">
                        @for (error of errors; track error) {
                          <div class="p-error block">
                            <em class="pi pi-times-circle"></em>
                            <small role="alert">
                              {{ error }}
                            </small>
                          </div>
                        }
                      </div>
                    </div>
                  </ng-container>
                  <div class="clearfix text-center mb-3">
                    <button
                      class="btn btn-primary"
                      (click)="save()"
                      formSubmit
                      [isFormValid]="changePasswordForm.valid"
                      tabindex="0">
                      {{ label }}
                      @if (label === 'Please wait ...') {
                        <em class="fa fa-spinner fa-spin me-2"></em>
                      }
                    </button>
                  </div>
                  @if (isTimerDone) {
                    <p class="text-center mb-10">
                      Didn't receive a verification code?
                      <a href="javascript:;" (click)="onResend()" title="Didn't receive a verification code"
                        >Resend code.</a
                      >
                    </p>
                  }
                  <div tabindex="0" class="clearfix text-center notranslate">
                    {{ time }}
                  </div>
                  @if (!isTimerDone) {
                    <p
                      role="alert"
                      class="text-12 text-center font-weight-bold no-mar requiredfield text-danger sr-only">
                      Timer Started for 1 minute 30 seconds
                    </p>
                  }
                  @if (isTimerDone) {
                    <p
                      role="alert"
                      class="text-12 text-center font-weight-bold no-mar requiredfield text-danger sr-only">
                      Timer Expired
                    </p>
                  }
                  <p class="rememberPassword text-center w-100" for="">
                    <a class="btn-link loginLabel" (click)="routeToLogin()" href="javascript:void(1)" tabindex="0"
                      >Back to Username</a
                    >
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  class="clsDialogCloseIconRemove"
  (onHide)="close()"
  [visible]="visible"
  [modal]="true"
  [focusTrap]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '60vw' }"
  [resizable]="false"
  [attr.role]="visible ? 'dialog' : null"
  [attr.aria-labelledby]="visible ? 'dialog-title-trans' : null"
  [attr.aria-describedby]="visible ? 'dialog-content-trans' : null">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center justify-content-between">
      <div class="clearfix">
        <h2 id="dialog-title-trans" class="clearfix no-mar clsDialogTitle">
          Automatic Translation Disclaimer<br />
          Descargo de responsabilidad por traducción automática
        </h2>
      </div>
      <button #accept type="button" class="btn btn-link no-mar clsCloseBtn" (click)="close()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
          <path
            d="M38.57 29.0019L56.5131 11.0588C58.4956 9.07625 58.4956 5.86208 56.5131 3.88265L54.1211 1.49061C52.1379 -0.492534 48.9238 -0.492534 46.9443 1.49061L29.0019 19.4331L11.0588 1.48689C9.07625 -0.495631 5.86208 -0.495631 3.88265 1.48689L1.48689 3.87893C-0.495631 5.86208 -0.495631 9.07625 1.48689 11.0557L19.4331 29.0019L1.49061 46.9443C-0.492534 48.9275 -0.492534 52.1416 1.49061 54.1211L3.88265 56.5131C5.86518 58.4956 9.07934 58.4956 11.0588 56.5131L29.0019 38.57L46.9443 56.5131C48.9275 58.4956 52.1416 58.4956 54.1211 56.5131L56.5131 54.1211C58.4956 52.1379 58.4956 48.9238 56.5131 46.9443L38.57 29.0019Z" />
        </svg>
      </button>
    </div>
  </ng-template>

  <div class="clearfix mb-4 clsTranslation">
    <p class="mb-3" id="dialog-content-trans">
      The State of West Virginia provides automatic translation for Communication & Operations Mobile Engagement Tool
      into two languages, courtesy of Google Translate. Please remember, though, that the English language version is
      considered the most accurate. In the event of a disagreement or discrepancy between the translation and the
      original English version of this web site or any notice or disclaimer, the original English version will prevail.
      <br /><br />
      El Estado de West Virginia proporciona traducción automática para Communication & Operations Mobile Engagement
      Tool a dos idiomas, por cortesía de Google Translate. No obstante, recuerde que la versión en inglés se considera
      la más exacta. En caso de desacuerdo o discrepancia entre la traducción y la versión original en inglés de este
      sitio web o cualquier aviso o descargo de responsabilidad, prevalecerá la versión original inglés.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="clearfix sep-top clsMarMinus"></div>
    <div class="clearfix pt-3 text-right">
      <button type="button" class="btn btn-primary" (click)="acceptLanguage()">Accept / Aceptar</button>
      <button type="button" class="btn btn-cancel ms-3" (click)="close()">Do Not Accept / No Aceptar</button>
    </div>
  </ng-template>
</p-dialog>

<!-- main loader -->
@if (loader) {
  <div id="loaderAnimation" class="loaderAnimation">
    <div class="loadingGifAnimation clearfix">
      <div class="loadingInner clearfix">
        <img class="logoCenterLoading" src="assets/images/Loader-new.gif" role="img" alt="lodergif" />
      </div>
    </div>
  </div>
}
